/**
 * Links left after a delete while the task is not saved yet.
 *
 * Those links have no row id. The id is the row's place in the list:
 * a number, or the decimal text of that number. Anything else names
 * no row. Return the same list. Never guess the first row.
 */
export function linksAfterAddModeDelete<T>(
  links: T[] | undefined,
  linkId: string | number,
): T[] | undefined {
  const index = addModeLinkIndex(linkId, links?.length ?? 0);
  if (index === null || links === undefined) return links;
  return links.filter((_, i) => i !== index);
}

/**
 * Place of an unsaved link. A number is that place. Text is that place only
 * when it is the same digits the screen uses (`"0"`, `"1"`, …). A partial
 * match, such as `"1abc"`, names no row.
 */
function addModeLinkIndex(
  linkId: string | number,
  linkCount: number,
): number | null {
  const index = typeof linkId === "number" ? linkId : exactDecimal(linkId);
  if (index === null || !Number.isInteger(index) || index < 0 || index >= linkCount) {
    return null;
  }
  return index;
}

function exactDecimal(linkId: string): number | null {
  if (!/^\d+$/.test(linkId)) return null;
  const index = Number(linkId);
  if (!Number.isInteger(index) || String(index) !== linkId) return null;
  return index;
}
